import React from "react";
import _Form from "./../_Form";
import { Card, CardBody, Container, Col, Row } from "reactstrap";

import { connect } from "react-redux";
import { add, edit, get, getDetails } from "./../../store/ducks/clothingColors";

import {
  Form,
  FormInput,
  FormInputColor,
  FormSelect,
  Header
} from "./../../components";

import Yup from "../../utils/yup";

const validationSchema = Yup.object().shape({
  title: Yup.string()
    .nullable()
    .required()
});

class ClothingColorsForm extends _Form {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      allColors: [],
      breadcrumbs: [
        {
          title: "Cores",
          to: this.props.module
        }
      ],
      id: false
    };
  }

  async componentDidMount() {
    await super.componentDidMount();

    const { loadingBar } = this.props;
    if (loadingBar) {
      loadingBar.staticStart(35);
    }

    await this.props.get({ unlimited: true });
    this.setState({
      allColors: this.props.list
        .filter(color => !this.state.id || color.id !== this.state.id)
        .map(color => {
          return {
            value: color.id,
            label: color.title
          };
        })
    });

    if (loadingBar) {
      loadingBar.complete();
    }
  }

  render() {
    const { allColors, breadcrumbs, fields } = this.state;

    return (
      <>
        <Header breadcrumbs={breadcrumbs} />
        {/* Page content */}
        <Container className="mt--7 bg-default" fluid>
          {/* Table */}
          <Row>
            <Col>
              <Card className="shadow">
                <CardBody className="position-relative">
                  <Form
                    buttonSubmit="Salvar"
                    initialValues={fields}
                    onSubmit={this.onFormSubmit}
                    validationSchema={validationSchema}
                    render={formProps => (
                      <>
                        <Row>
                          <FormInput
                            label="Título"
                            name="title"
                            lg={6}
                            sm={6}
                            xs={12}
                          />
                          <FormInputColor
                            label="Cor"
                            name="color"
                            noPadding={true}
                            lg={6}
                            sm={6}
                            xs={12}
                          />
                          <FormSelect
                            findDefaultValues={values => {
                              if (values && values.length) {
                                return values.map(val => {
                                  const option = allColors.find(i => {
                                    return i.value === val;
                                  });
                                  return option ? { ...option } : null;
                                });
                              } else {
                                return [];
                              }
                            }}
                            isMulti={true}
                            label="Cores que não combinam"
                            name="restrictions"
                            options={allColors}
                            lg={12}
                            sm={12}
                            xs={12}
                          />
                        </Row>
                      </>
                    )}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

const mapStateToProps = ({ common, clothingColors }) => ({
  list: clothingColors.data,
  details: clothingColors.details,
  loadingBar: common.loadingBar,
  module: clothingColors.module
});

const mapDispatchToProps = {
  add,
  edit,
  get,
  getDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(ClothingColorsForm);
